const API_URL = process.env.REACT_APP_API_URL;
const Apis = {
  UserLoginAPI: `${API_URL}/api/root/login`,
  UserLoginEmployeAPI: `${API_URL}/api/root/employe/login`,
  api_updatecridentials: `${API_URL}/api/root/update/credentials`,

};
const ApiSupperSettings = {

  api_UsersAdmin: `${API_URL}/api/users/admin`,
  api_UsersEmploye: `${API_URL}/api/list/users/employes`,
  
  api_UsersAdmin_update: `${API_URL}/api/users/admin/`,
  api_Privilege: `${API_URL}/api/privileges/list`,
  api_Privilege_update: `${API_URL}/api/privileges/list/`,
  api_ConfigApplications: `${API_URL}/api/general/configs/rh/applications`,
  api_BaseSettings: `${API_URL}/api/base/settings/list`,
  ////////////////////////////////////////////////////////////////////////////////////////
  api_Locations: `${API_URL}/api/contrib/settings/locations/`,
  api_LevelAdminstrations: `${API_URL}/api/contrib/level/settings/administartion/`,
  api_SkillsAibilities: `${API_URL}/api/contrib/skill/settings/competances/`,
  api_JobsFramework: `${API_URL}/api/contrib/framework/settings/status/`,
  api_JobsFramework_details: `${API_URL}/api/contrib/framework/settings/status/`,
  api_EntryServices: `${API_URL}/api/contrib/entry/services/status/`,
  api_OfficialPosition: `${API_URL}/api/contrib/official/position/status/`,
  api_PermanentActivities: `${API_URL}/api/contrib/permanent/activities/status/`,
  api_OrganizationFunctions: `${API_URL}/api/contrib/settings/organizations/functions/`,
  api_OrganizationFunctionsDetails: `${API_URL}/api/contrib/settings/organization/details/`,
 //////////////////////////////////////////////////////////////:
  api_JobsConfigs: `${API_URL}/api/initial/modules/jobs/settings/configs/`,
  api_JobsConfigsDetails: `${API_URL}/api/details/configs/jobs/ability/configs/`,
  


 ////////////////////////////////////////API details//////////////////////:

 api_structureDigramme : `${API_URL}/api/list/structures/details/orgs/structure/orgs`,
 api_OrganizationFunctionsOrgs : `${API_URL}/api/contrib/settings/organization/details/heararchies/orgs/entity`,
 

};

export { API_URL, Apis, ApiSupperSettings };